import { Cache } from "memory-cache";
import { CorporationMemberEntity } from ".";

// Cache
const cache = new Cache();

export async function getCachedCorporationMemberEntity(character_id: number): Promise<CorporationMemberEntity | null> {
  let entity: any = await cache.get("membertracking-" + character_id.toString());
  if (entity) {
    return entity;
  } else return null;
}

export function setCachedCorporationMemberEntity(member: CorporationMemberEntity) {
  cache.put("membertracking-" + member.props.id, member, 60 * 60 * 1000 /* 1 hour */);
}
